import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { BuildingCreateForm } from "@/features/building/BuildingCreateForm";

export function BuildingCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/category-bizzpass",
            label: "Category BizzPass",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add Category Bizzpass</H2>
      <BuildingCreateForm />
    </>
  );
}
